// src/components/Header.jsx
import React from "react";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <header className="w-full border-b border-black/5 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/70">
      <div className="flex h-14 w-full items-center px-6">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80">
          {/* Logo Container */}
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-white border border-[#DEF1FF] overflow-hidden shadow-sm">
            <img
              src="/steffi/logo.png"
              alt="Logo"
              className="h-12 w-12 object-contain"
            />
          </div>
          <span className="text-xl font-semibold tracking-wide text-indigo-700">
            SteffiCare
          </span>
        </Link>
      </div>
    </header>
  );
}